import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Avatar,
  Button,
  Dialog,
  DialogContent,
  TextField,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useNavigate } from "react-router-dom";

import ProfileIConeEarn from "../../assets/earnprofileicon.png";
import Icon from "../../assets/iconEarn.png";

const ReferEarnComp = (props) => {
  const navigate = useNavigate();
  const referCode = localStorage.getItem("referCode");

  const [inputValue, setInputValue] = useState(referCode || "");

  const handleBack = () => navigate("/profile");

  const handleShare = async () => {
    if (navigator.share) {
      try {
        const shareUrlAndroid =
          "http://play.google.com/store/apps/details?id=app.daalchini.com";
        const shareUrlIos =
          "https://apps.apple.com/in/app/daalchini-healthy-home-food/id1443105751";

        const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);
        const isAndroid = /android/i.test(navigator.userAgent);

        const shareUrl = isIos
          ? shareUrlIos
          : isAndroid
          ? shareUrlAndroid
          : window.location.href;

        await navigator.share({
          title:
            "Buying Healthy Home Food becomes faster and better at Daalchini Kiosk.",
          text: `Now try this App to buy from Daalchini Kiosk.\n${shareUrl}\nUse code ${referCode} to earn Daalchini Cashback.`,
          url: shareUrl,
        });
      } catch (err) {}
    } else {
      alert("Web Share API not supported.");
    }
  };

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(inputValue);
    alert("Copied: " + inputValue);
  };

  return (
    <Box sx={{ bgcolor: "#eef6ff", minHeight: "100vh", fontFamily: "Roboto" }}>
      
      {/* HEADER */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          bgcolor: "#fae14b",
          display: "flex",
          alignItems: "center",
          p: 1.5,
          zIndex: 10,
        }}
      >
        <IconButton onClick={handleBack}>
          <ArrowBackIcon />
        </IconButton>

        <Typography variant="h6" fontWeight={600}>
          Refer & Earn
        </Typography>
      </Box>

      {/* BODY */}
      <Box
        sx={{
          maxWidth: 420,
          mx: "auto",
          textAlign: "center",
          p: 3,
        }}
      >
        <Avatar
          src={ProfileIConeEarn}
          sx={{ width: 90, height: 90, mx: "auto", mb: 2 }}
        />

        <Typography variant="h6" fontWeight={700}>
          Refer & Earn
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Share this code with your friends. When they order using Daalchini App
          for the first time, you both get ₹ 10.
        </Typography>

        {/* CODE */}
        <Typography variant="caption" sx={{ mt: 3, display: "block" }}>
          YOUR CODE
        </Typography>

        <Box
          sx={{
            border: "2px dashed #e0e0e0",
            borderRadius: 2,
            p: 1.5,
            mt: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={{
              color: "#00B177",
              fontWeight: 700,
              letterSpacing: 2,
            }}
          >
            {referCode}
          </Typography>

          <IconButton onClick={copyToClipboard}>
            <ContentCopyIcon />
          </IconButton>
        </Box>

        {/* APPLY COUPON */}
        <Box
          sx={{
            mt: 3,
            border: "1px solid #e0e0e0",
            borderRadius: 3,
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2">
            Have a coupon code?
          </Typography>

          <Button
            variant="contained"
            size="small"
            sx={{
              bgcolor: "#00B177",
              "&:hover": { bgcolor: "#009966" },
            }}
            onClick={() => props?.setEarnModal(true)}
          >
            Apply
          </Button>
        </Box>

        {/* TERMS */}
        <Typography
          component="a"
          href="https://www.daalchini.co.in/terms.html"
          sx={{
            display: "block",
            mt: 3,
            fontSize: 12,
            textDecoration: "underline",
            color: "text.secondary",
          }}
        >
          Terms & Conditions
        </Typography>

        {/* INVITE BUTTON */}
    <Box
  sx={{
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    //bgcolor: "#fff",
    p: 2,
    //boxShadow: "0 -2px 10px rgba(0,0,0,0.05)",
  }}
>
  <Button
    fullWidth
    variant="outlined"
    onClick={handleShare}
    sx={{
      borderRadius: 2,
      textTransform: "uppercase",
      fontWeight: 600,
      color: "#00B177",
      borderColor: "#e0e0e0",

      "&:hover": {
        borderColor: "#e0e0e0",
        backgroundColor: "#e0e0e0",
      },
    }}
  >
    Invite your Friends
  </Button>
</Box>

      </Box>

      {/* MODAL */}
      <Dialog
        open={props?.earnModal}
        onClose={() => props?.setEarnModal(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogContent sx={{ textAlign: "center", p: 3 }}>
          <Avatar
            src={Icon}
            sx={{ width: 70, height: 70, mx: "auto", mb: 2 }}
          />

          <Typography fontWeight={700}>
            Enter Coupon Code
          </Typography>

          <TextField
            fullWidth
            placeholder="Enter code"
            sx={{ mt: 2 }}
            onChange={(e) => props?.handleReferCode(e)}
          />

          <Button
            fullWidth
            variant="contained"
            sx={{
              mt: 3,
              bgcolor: "#00B177",
              "&:hover": { bgcolor: "#009966" },
            }}
            onClick={props?.ApplyReferCode}
          >
            Check
          </Button>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ReferEarnComp;
